<template>
  <div>
    <v-dialog
      v-model="showModalEditContact"
      persistent
      max-width="600px"
      :fullscreen="isMobile"
    >
      <v-card>
        <HeaderModals
          :titleModal="$t('profile.addressBook.edit-contact')"
        ></HeaderModals>
        <v-card-text>
          <v-container>
            <v-row v-if="!isEditingNotesOnly">
              <v-col :cols="isMobile ? 12 : 6" class="pb-0">
                <v-text-field
                  v-model="contact.titel"
                  dense
                  outlined
                  hide-details
                  :label="'Titel'"
                  required
                ></v-text-field>
              </v-col>
              <v-col :cols="isMobile ? 12 : 6" class="pb-0">
                <v-text-field
                  v-model="contact.first_name"
                  dense
                  outlined
                  hide-details
                  :label="$t('profile.addressBook.firstname') + '*'"
                  required
                  maxLength="20"
                ></v-text-field>
              </v-col>
              <v-col :cols="isMobile ? 12 : 6" class="pb-0">
                <v-text-field
                  v-model="contact.last_name"
                  dense
                  outlined
                  hide-details=""
                  :label="$t('profile.addressBook.lastname') + '*'"
                  required
                  maxLength="20"
                ></v-text-field>
              </v-col>
              <v-col :cols="isMobile ? 12 : 6" class="pb-0">
                <v-text-field
                  v-model="contact.email"
                  dense
                  outlined
                  hide-details
                  :label="$t('profile.addressBook.email') + '*'"
                  required
                  :rules="emailRules"
                ></v-text-field>
              </v-col>
              <v-col :cols="isMobile ? 12 : 6" class="pb-0">
                <vue-tel-input
                  v-model="contact.phone"
                  defaultCountry="ES"
                  enabledCountryCode
                  @onInput="onTelInput"
                  name="number"
                  id="numDisplay"
                  class="focusStyle form-control text-center input-sm inputPhone2FA"
                  value
                  placeholder
                  autocomplete="off"
                  :class="{
                    borderError: !phoneInputValid && contact.phone !== ''
                  }"
                ></vue-tel-input>
              </v-col>
              <v-col :cols="isMobile ? 12 : 6" class="pb-0">
                <v-checkbox
                  class="mt-0"
                  v-model="contact.hasWhatsapp"
                  :label="$t('profile.addressBook.has-whatsapp')"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  v-model="contact.note"
                  dense
                  outlined
                  hide-details
                  :label="$t('profile.addressBook.notes')"
                ></v-text-field>
              </v-col>
            </v-row>
            <p v-if="messageFound" class="mb-0 mt-3 text-left errorText">
              {{ $t("profile.addressBook.already-exists") }}
            </p>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="
              closeModalEditContact();
              messageFound = false;
            "
          >
            {{ $t("paymentModals.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="contactExists()"
            :disabled="disableSaveContact"
            :loading="loading"
          >
            {{ $t("paymentModals.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import HeaderModals from "./commons/headerModals.vue";
import { isMobile } from "../../utils";
export default {
  components: { HeaderModals},
  name: "addContactModal",
  props: ["showModalEditContact", "closeModalEditContact", "handleEditContact", "contact", "loading", "contacts", "isEditingNotesOnly"],
  data: () => ({
    isMobile: isMobile(),
    emailRules: [
        v => !!v || "E-mail is required",
        v =>
          // eslint-disable-next-line no-useless-escape
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail is invalid"
      ],
    creatingLink: false,
    messageFound: false,
    contactMail: '',
    contactPhone: '',
    phoneInputValid: true
  }),
  watch:{
      "contact.email":{
          inmediate: true,
          handler: function(val){
              this.contactMail = val;
          }
      }
  },
  methods:{
    onTelInput({ number, isValid, country }) {
        if ( this.contact.phone !== "" ){
            
            if (isValid) {
                this.contact.phone = number.international.replace(/\s/g, "");
            }
            this.phoneInputValid = isValid;
        }else{
            this.phoneInputValid = true;
        }
    },
    contactExists(){
        let exists = false;
        this.messageFound = false;
        if ( this.contacts.length ){
            this.contacts.forEach(contact => {
                if ( (contact.email == this.contact.email || (this.contact.phone !== '' && contact.phone == this.contact.phone)) && contact.key !== this.contact.key ){
                    exists = true;
                }
            });
        }
        if ( exists ){
            this.messageFound = true;
        }else{
            this.messageFound = false;
            this.handleEditContact(
            this.contact.first_name,
            this.contact.last_name,
            this.contact.email,
            this.contact.phone,
            this.contact.hasWhatsapp,
            this.contact.key,
            this.contact.titel,
            this.contact.note);
        }
    }
  },
  computed:{
    isValidEmail(){
      return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            this.contact.email
          )
    },
    user(){
      return this.$store.state.user.user
    },
    disableSaveContact(){
        return this.contact.first_name == "" || this.contact.last_name == "" || this.contact.email == "" || !this.phoneInputValid || !this.isValidEmail;
    }
  }
};

</script>
<style scoped lang="scss">
.call{
  .v-dialog{
    .v-card {
      background: rgba(0,0,0,0.6);
      color: #cccccc;
    }
    .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
      background-color: rgb(181 181 181 / 45%) !important;
      color: white !important;
    }
  }
}
.copiedAlert{
  position: absolute;
  top: 15px;
  right: 36px;
  margin: 0;
  width: auto;
  z-index: 999;
}
.errorText{
    color: red;
}
.borderError {
   border-color: red !important;
}
</style>

<style lang="scss">
#numDisplay{
    .vti__dropdown-list.below{
      width: 277px;
      max-height: 103px;
    }
}
.vue-tel-input{
  font-size: 16px;
}
</style>
